import MainMenuApp from "./main-menu-app";

import "./main-menu.scss";

const MainMenu = {
    App : MainMenuApp
}

export default MainMenu;